import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IFilters, TSortType } from '../../types/filters';

export enum EFilterActionTypes {
  SetAll = 'FILTERS/SET_ALL',
  SetRegion = 'FILTERS/SET_REGION',
  SetSortType = 'FILTERS/SET_SORT_TYPE',
  SetSearchText = 'FILTERS/SET_SEARCH_TEXT',
  SetPage = 'FILTERS/SET_PAGE',
}

export const setAllFilters = actionGenerator<EFilterActionTypes.SetAll, IFilters>(EFilterActionTypes.SetAll);

export const setRegion = actionGenerator<EFilterActionTypes.SetRegion, number>(EFilterActionTypes.SetRegion);

export const setSortType = actionGenerator<EFilterActionTypes.SetSortType, TSortType>(EFilterActionTypes.SetSortType);

export const setSearchText = actionGenerator<EFilterActionTypes.SetSearchText, string>(
  EFilterActionTypes.SetSearchText,
);

export const setPage = actionGenerator<EFilterActionTypes.SetPage, number>(EFilterActionTypes.SetPage);

export type TFilterActions =
  | ReturnType<typeof setAllFilters>
  | ReturnType<typeof setRegion>
  | ReturnType<typeof setSortType>
  | ReturnType<typeof setSearchText>
  | ReturnType<typeof setPage>;
